"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XeroSyncPhase = exports.XeroSyncType = exports.XeroSyncStatus = void 0;
// packages/types/src/xero.ts
var XeroSyncStatus;
(function (XeroSyncStatus) {
    XeroSyncStatus["NEVER"] = "never";
    XeroSyncStatus["IDLE"] = "idle";
    XeroSyncStatus["SYNCING"] = "syncing";
    XeroSyncStatus["COMPLETE"] = "complete";
    XeroSyncStatus["ERROR"] = "error";
})(XeroSyncStatus || (exports.XeroSyncStatus = XeroSyncStatus = {}));
var XeroSyncType;
(function (XeroSyncType) {
    XeroSyncType["ACCOUNTS"] = "accounts";
    XeroSyncType["ASSETS"] = "assets";
    XeroSyncType["EMPLOYEES"] = "employees";
    XeroSyncType["PAYSLIPS"] = "payslips";
    XeroSyncType["TRANSACTIONS"] = "transactions";
    /** AP Invoices (Bills) from Xero's /Invoices?Type=ACCPAY endpoint */
    XeroSyncType["BILLS"] = "bills";
    /** Self-referencing invoice journals — opt-in per org */
    XeroSyncType["SELF_INVOICES"] = "self_invoices";
})(XeroSyncType || (exports.XeroSyncType = XeroSyncType = {}));
/**
 * Sub-step of a running sync, surfaced live so the UI can name what's actually
 * happening instead of a single static label. Only the multi-phase
 * `transactions` sync sets this — it runs bank transactions → bills →
 * self-invoices. Each phase also removes local rows for documents deleted in
 * Xero as its first step; that sweep is grouped under the phase's own label
 * rather than shown separately. Null for single-phase sync types.
 */
var XeroSyncPhase;
(function (XeroSyncPhase) {
    XeroSyncPhase["TRANSACTIONS"] = "transactions";
    XeroSyncPhase["BILLS"] = "bills";
    XeroSyncPhase["SELF_INVOICES"] = "self_invoices";
})(XeroSyncPhase || (exports.XeroSyncPhase = XeroSyncPhase = {}));
